export default "mutation CreateDevice($name: String!, $parentId: ID!) {\n  createGroup(\n    name: $name,\n    parentId: $parentId\n  ) {\n    id\n  }\n}\n"